import { Component } from "react";
import { Warning } from "@phosphor-icons/react";

/**
 * Límite de error local. Si el componente envuelto lanza una excepción,
 * renderiza un fallback amable SIN romper el resto de la página.
 */
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, message: "" };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, message: error?.message || "Error desconocido" };
  }

  componentDidCatch(error, info) {
    if (process.env.NODE_ENV !== "production") {
      // eslint-disable-next-line no-console
      console.error("[ErrorBoundary]", this.props.section || "", error, info);
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          className="flex items-start gap-3 p-4 border border-destructive/40 bg-destructive/5 rounded-md"
          data-testid={`error-boundary-${this.props.section || "default"}`}
        >
          <Warning size={20} weight="duotone" className="text-destructive shrink-0 mt-0.5" />
          <div className="text-sm">
            <div className="font-medium text-destructive">
              Esta sección no se pudo cargar{this.props.section ? `: ${this.props.section}` : ""}.
            </div>
            <div className="text-xs text-muted-foreground mt-1">
              El resto de la página sigue operativa. Detalle: {this.state.message}
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
